module.exports = __webpack_public_path__ + "static/img/normal-temperature-count.3bb4441.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/track/1/normal-temperature-count.png
// module id = 7dg+
// module chunks = 1